import { StrikeMethodApi } from '@voladeum/client';
import { v4 as uuidv4 } from 'uuid';

import { StrikeMethod } from './types';

export const normalizeStrikeMethods = (data: StrikeMethodApi[]): StrikeMethod[] =>
  data.map((d) => normalizeStrikeMethod(d));

export const normalizeStrikeMethod = (row: StrikeMethodApi): StrikeMethod => {
  return { ...row, uuid: uuidv4() };
};
